// src/pages/EventsPage.js
import React, { useState, useEffect } from 'react';
import { Container, Box, Button, Typography } from '@mui/material';
import EventCreationModal from '../features/collaboration/components/EventCreationModal';
import EventCard from '../features/collaboration/components/EventCard';
import { fetchEvents, subscribeToEvents } from '../features/collaboration/services/collaborationService';
import { useAuth } from '../contexts/AuthContext';

const EventsPage = () => {
  const { currentUser } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    let unsub;
    const load = async () => {
      setLoading(true);
      try {
        const evs = await fetchEvents();
        setEvents(evs);
      } catch (err) {
        console.error('Failed to load events', err);
      } finally {
        setLoading(false);
      }
      // subscribe for real-time changes
      unsub = subscribeToEvents((updated) => setEvents(updated));
    };
    load();
    return () => unsub && unsub();
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Events</Typography>
        <Button variant="contained" onClick={() => setOpenCreate(true)}>Create Event</Button>
      </Box>

      <Box>
        {loading ? <Typography>Loading events…</Typography> : (
          events.length === 0 ? <Typography>No upcoming events</Typography> : events.map(ev => (
            <EventCard key={ev.id} event={ev} />
          ))
        )}
      </Box>

      <EventCreationModal open={openCreate} onClose={() => setOpenCreate(false)} onCreated={(e) => {
        // Optionally navigate to event or show toast
      }} />
    </Container>
  );
};

export default EventsPage;
